// modules/Preloader/PreloaderLoadLogic.js
// 预加载器加载逻辑模块

import ResourceLoader from '../ResourceLoader.js';
import { RESOURCE_CONFIG } from '../ResourceConfig.js';

export default class PreloaderLoadLogic {
    constructor(scene) {
        this.scene = scene;
    }
    
    /**
     * 加载所有资源
     * @param {Function} onProgress - 进度回调 (progress, status) => void
     * @param {Function} onFileComplete - 文件完成回调 (key, type, data) => void
     */
    loadAllResources(onProgress, onFileComplete) {
        // 监听加载进度
        this.scene.load.on('progress', (progress) => {
            if (onProgress) {
                onProgress(progress * 100, this.getLoadingStatus(progress));
            }
        });
        
        // 监听文件加载完成
        this.scene.load.on('filecomplete', (key, type, data) => {
            if (onFileComplete) {
                onFileComplete(key, type, data);
            }
        });
        
        // 使用 ResourceLoader 加载资源
        this.loadPlayerAvatar();
        this.loadEquipmentSilhouettes();
        this.loadEquipmentIcons();
        this.loadCriticalResources();
        this.loadEssentialAudio();
        this.loadGameData();
    }
    
    /**
     * 根据加载进度获取状态文本
     * @param {number} progress - 进度值 (0-1)
     * @returns {string} 状态文本
     */
    getLoadingStatus(progress) {
        if (progress < 0.2) {
            return '正在加载游戏资源...';
        } else if (progress < 0.4) {
            return '正在加载角色和NPC...';
        } else if (progress < 0.6) {
            return '正在加载地图数据...';
        } else if (progress < 0.95) {
            return '正在加载音效和音乐...';
        } else {
            return '即将完成...';
        }
    }
    
    /**
     * 加载玩家头像
     */
    loadPlayerAvatar() {
        ResourceLoader.loadImages(this.scene, RESOURCE_CONFIG.playerAvatars);
    }
    
    /**
     * 加载装备展示图片
     */
    loadEquipmentSilhouettes() {
        ResourceLoader.loadImages(this.scene, RESOURCE_CONFIG.equipmentSilhouettes);
    }
    
    /**
     * 加载装备图标
     */
    loadEquipmentIcons() {
        ResourceLoader.loadImages(this.scene, RESOURCE_CONFIG.equipmentIcons);
    }
    
    /**
     * 加载关键资源
     */
    loadCriticalResources() {
        // 加载玩家精灵图
        ResourceLoader.loadSpritesheets(this.scene, RESOURCE_CONFIG.players);
        
        // 加载NPC精灵图
        ResourceLoader.loadSpritesheets(this.scene, RESOURCE_CONFIG.npcs);
        
        // 加载战车精灵图
        ResourceLoader.loadSpritesheets(this.scene, RESOURCE_CONFIG.tanks);

        if (RESOURCE_CONFIG.enemies && RESOURCE_CONFIG.enemies.length > 0) {
            ResourceLoader.loadSpritesheets(this.scene, RESOURCE_CONFIG.enemies);
        }
    }
    
    /**
     * 加载启动必需音频
     */
    loadEssentialAudio() {
        ResourceLoader.loadAudios(this.scene, RESOURCE_CONFIG.essentialAudio);
    }
    
    /**
     * 加载背景音乐和音效（已改为按需加载，保留供手动调用）
     */
    loadBgm() {
        ResourceLoader.loadAudios(this.scene, RESOURCE_CONFIG.bgm);
        ResourceLoader.loadAudios(this.scene, RESOURCE_CONFIG.soundEffects);
    }
    
    /**
     * 加载游戏数据
     */
    loadGameData() {
        ResourceLoader.loadJSONs(this.scene, RESOURCE_CONFIG.jsonData);
    }
}

